import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-3 border border-gray-200 shadow-lg rounded-lg">
        <p className="font-bold mb-1">شهر {label.split('-')[1]}-{label.split('-')[0]}</p>
        {payload.map((p, index) => (
          <p key={index} className="text-sm">
            {p.dataKey === 'investment' ? 'المدخرات' : 'القيمة'}: 
            <span className="font-bold mr-2 ltr inline-block">
              EGP {p.value.toLocaleString()}
            </span>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const InvestmentChart = ({ reportData }) => {
  if (!reportData?.performance_metrics?.monthly_data) {
    return null;
  }

  // Format data to include both investment and value
  const chartData = reportData.performance_metrics.monthly_data.map(item => {
    const investment = parseFloat(item.investment);
    return {
      month: item.month,
      investment: investment,
      value: investment * (1 + (reportData.purchase_metrics.return_percentage / 100))
    };
  });

  const formatYAxis = (value) => {
    if (value >= 1000) {
      return `${(value/1000).toFixed(0)}K`;
    }
    return value;
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-lg mb-6">
      <h3 className="text-lg font-bold mb-4 text-[#234363]">رحلة الاستثمار</h3>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart 
            data={chartData}
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
          >
            <CartesianGrid 
              strokeDasharray="3 3" 
              stroke="#E5E7EB" 
              vertical={false}
            />
            <XAxis 
              dataKey="month" 
              tickFormatter={(value) => value.split('-')[1]}
              stroke="#9CA3AF"
              tick={{ fill: '#6B7280', fontSize: 12 }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <YAxis 
              tickFormatter={formatYAxis}
              stroke="#9CA3AF"
              tick={{ fill: '#6B7280', fontSize: 12 }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <Tooltip 
              content={<CustomTooltip />}
              cursor={{ stroke: '#E5E7EB', strokeDasharray: '3 3' }}
            />
            <Line 
              type="monotone" 
              dataKey="investment"
              stroke="#234363" 
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 6, fill: '#234363' }}
            />
            <Line 
              type="monotone" 
              dataKey="value"
              stroke="#FFBE2E" 
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 6, fill: '#FFBE2E' }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default InvestmentChart;